(() => {
  const instances = new Map();
  const reopenSections = new Set();

  function initializeNisOffers() {
    document.querySelectorAll('[data-nis-offers]').forEach(root => {
      const id = root.dataset.sectionId;
      if (instances.get(id)?.root === root) return;
      instances.get(id)?.destroy();
      const events = new AbortController();
      const signal = events.signal;
      const dialog = root.querySelector('dialog');
      const tab = root.querySelector('.nis-offers__tab');
      const opener = root.querySelector('.nis-offers__open');
      const status = root.querySelector('.nis-offers__status');
      const timers = new Set();
      let previousOverflow = '';
      let locked = false;

      function unlock() {
        if (!locked) return;
        document.documentElement.style.overflow = previousOverflow;
        opener.setAttribute('aria-expanded', 'false');
        locked = false;
      }

      function open() {
        if (dialog.open) return;
        tab.hidden = false;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        locked = true;
        document.documentElement.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
      }

      opener.addEventListener('click', open, { signal });
      root.querySelector('.nis-offers__dismiss').addEventListener('click', () => { tab.hidden = true; }, { signal });
      root.querySelector('.nis-offers__close').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, { signal });
      dialog.addEventListener('close', () => {
        unlock();
        if (root.isConnected) opener.focus();
      }, { signal });

      root.querySelectorAll('.nis-offers__copy').forEach(copy => {
        const label = copy.textContent;
        copy.addEventListener('click', async () => {
          copy.disabled = true;
          try {
            if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(copy.dataset.code);
            else {
              const field = document.createElement('textarea');
              field.value = copy.dataset.code;
              field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
              dialog.append(field);
              field.select();
              const success = document.execCommand('copy');
              field.remove();
              copy.focus();
              if (!success) throw new Error('copy');
            }
            if (!root.isConnected) return;
            copy.textContent = copy.dataset.copied;
            status.textContent = copy.dataset.copied + ' ' + copy.dataset.code;
            const timer = setTimeout(() => {
              copy.textContent = label;
              copy.disabled = false;
              timers.delete(timer);
            }, 2000);
            timers.add(timer);
          } catch {
            status.textContent = copy.dataset.error + ' ' + copy.dataset.code;
            copy.disabled = false;
          }
        }, { signal });
      });

      const instance = {
        root,
        open,
        dialog,
        destroy() {
          events.abort();
          timers.forEach(clearTimeout);
          if (dialog.open) dialog.close();
          unlock();
        }
      };
      instances.set(id, instance);
      if (reopenSections.delete(id)) open();
    });
  }

  initializeNisOffers();
  document.addEventListener('shopify:section:load', initializeNisOffers);
  document.addEventListener('shopify:section:unload', event => {
    const id = event.detail.sectionId;
    const instance = instances.get(id);
    if (!instance) return;
    if (instance.dialog.open) reopenSections.add(id);
    instance.destroy();
    instances.delete(id);
  });
  document.addEventListener('shopify:block:select', event => {
    const instance = instances.get(event.detail.sectionId);
    if (!instance) return;
    instance.open();
    const card = Array.from(instance.root.querySelectorAll('[data-coupon-id]')).find(item => item.dataset.couponId === event.detail.blockId);
    card?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  });
})();
